







































































































































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
@Component({
  components: {}
})
export default class SideBar extends Vue {
  popup = false; //联系我们弹窗
  scrollTop = 0;
  msgFlag = false;
  contactFlag = false;
  btnFlag = false;
  dialogFormVisible3 = false;
  textarea = "";
  options = [
    {
      value: "政府",
      label: "政府"
    },
    {
      value: "金融",
      label: "金融"
    },
    {
      value: "电力",
      label: "电力"
    }
  ];
  value = "";
  form2 = {
    direction: "",
    class: "",
    time: "",
    address: "",
    school: "",
    phone: "",
    num: "",
    email: "",
    code: ""
  };
  formLabelWidth = "120px";

  industryList: any = []; //行业列表
  contactForm = {
    demand: "", //需求
    username: "", //姓名
    phone: "", //电话
    email: "", //邮箱
    name: "", //名称
    // motif: "", //主题
    time: "", //时间
    industry: "", //所在行业
    city: "", //所在城市
    company: "" //所在单位
  };
  contactRules: any = {
    demand: [
      {
        required: true,
        message: "请输入您在合作/培训中的问题：",
        trigger: "blur"
      }
    ],
    username: [
      { required: true, message: "请输入您的姓名", trigger: "blur" },
      { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" }
    ],
    phone: [{ validator: this.checkPhone, trigger: "blur" }],
    email: [{ validator: this.checkEmail, trigger: "blur" }],
    city: [{ required: true, message: "请输入所在城市", trigger: "blur" }],
    time: [{ required: true, message: "请输入合作/培训时间", trigger: "blur" }],
    name: [{ required: true, message: "请输入合作/培训名称", trigger: "blur" }],
    // motif: [
    //   { required: true, message: "请输入合作/培训主题", trigger: "blur" }
    // ],
    industry: [{ required: true, message: "请选择行业", trigger: "change" }],
    company: [{ required: true, message: "请输入所在单位", trigger: "blur" }]
  };
  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
    this.getIndustry();
  }
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  }

  checkEmail(rule, value, callback) {
    const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
    if (!value) {
      return callback(new Error("邮箱不能为空"));
    }
    setTimeout(() => {
      if (mailReg.test(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的邮箱格式"));
      }
    }, 100);
  }
  //手机验证
  checkPhone(rule, value, callback) {
    const phoneReg = /^1[3|4|5|7|8][0-9]{9}$/;
    if (!value) {
      return callback(new Error("电话号码不能为空"));
    }
    setTimeout(() => {
      // Number.isInteger是es6验证数字是否为整数的方法,但是我实际用的时候输入的数字总是识别成字符串
      // 所以我就在前面加了一个+实现隐式转换
      if (!Number.isInteger(+value)) {
        callback(new Error("请输入数字值"));
      } else {
        if (phoneReg.test(value)) {
          callback();
        } else {
          callback(new Error("电话号码格式不正确"));
        }
      }
    }, 100);
  }

  onSubmit() {
    this.dialogFormVisible3 = false;
  }
  problemSub() {
    this.dialogFormVisible3 = true;
  }
  contactEnter() {
    this.contactFlag = true;
  }
  contactLeave() {
    this.contactFlag = false;
  }
  msgEnter() {
    this.msgFlag = true;
  }
  msgLeave() {
    this.msgFlag = false;
  }
  feedBack() {
    this.$router.push({ path: "/home/feedback" });
  }
  goTop() {
    document.documentElement.scrollTop = document.body.scrollTop = 0;
  }
  scrollToTop() {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    this.scrollTop = scrollTop;
    if (this.scrollTop > 60) {
      this.btnFlag = true;
    } else {
      this.btnFlag = false;
    }
  }

  contactSubmit(formName) {
    (this.$refs[formName] as any).validate(valid => {
      if (valid) {
        const formData: any = {};
        formData.pxtime = this.contactForm.time;
        formData.pxcontent = this.contactForm.demand;
        formData.phone = this.contactForm.phone;
        formData.city = this.contactForm.city;
        // formData.hzpxzt = this.contactForm.motif;
        formData.name = this.contactForm.username;
        formData.industry = this.contactForm.industry;
        formData.company = this.contactForm.company;
        formData.pxname = this.contactForm.name;
        this.subMission(formData, formName);
      } else {
        // console.log("error submit!!");
        return false;
      }
    });
  }
  async getIndustry() {
    this.industryList = [
      {
        dictCode: "0058009",
        dictName: "政府",
        id: "q8O8tAt398670890991m8Z0u05j1585811229232",
        sort: 0,
        isMenu: 0,
        group: "058",
        createDate: 1585811229000
      },
      {
        dictCode: "0058008",
        dictName: "金融",
        id: "oEYHPc9Fc1neP7L3SnE1La3P36t1585811224927",
        sort: 0,
        isMenu: 0,
        group: "058",
        createDate: 1585811224000
      },
      {
        dictCode: "0058007",
        dictName: "交通",
        id: "834k0c5j1561596p2GH35U8bdYD1585811217521",
        sort: 0,
        isMenu: 0,
        group: "058",
        createDate: 1585811217000
      },
      {
        dictCode: "0058006",
        dictName: "电力",
        id: "1883Gb45sTx0IOOjJ9L69mS9KD51585811210544",
        sort: 0,
        isMenu: 0,
        group: "058",
        createDate: 1585811210000
      },
      {
        updateDate: 1585812778000,
        dictCode: "0058005",
        dictName: "公共安全",
        id: "t7f9O495Ho4xEyRdg8ISKgX3lk31585811198760",
        sort: 0,
        isMenu: 0,
        group: "058",
        createDate: 1585811198000
      },
      {
        dictCode: "0058004",
        dictName: "广电",
        id: "Mo05Rj7E7cuhusD7ScG86Nk679b1585811191257",
        sort: 0,
        isMenu: 0,
        group: "058",
        createDate: 1585811191000
      },
      {
        dictCode: "0058003",
        dictName: "教育",
        id: "cy0F23J5Wml9R59cq456WC651621585811175485",
        sort: 0,
        isMenu: 0,
        group: "058",
        createDate: 1585811175000
      },
      {
        dictCode: "0058002",
        dictName: "互联网",
        id: "0H36P34FbIBx817E8u33aL0Cw231585811167397",
        sort: 0,
        isMenu: 0,
        group: "058",
        createDate: 1585811167000
      },
      {
        updateDate: 1585811160000,
        dictCode: "0058001",
        dictName: "其他",
        id: "82Sh7xRz15NYK0jG0D54423401T1585811151543",
        sort: 0,
        isMenu: 0,
        group: "058",
        createDate: 1585811151000
      }
    ];
  }
  resetForm(formName) {
    (this.$refs[formName] as any).resetFields();
    // console.log(this.$refs[formName]);
    this.popup = false;
  }
  async subMission(data, formName) {
    //请求接口 提交信息
  }
}
